module.exports = require('./dist/gc.spread.excelio.min.js');